<template>
    <div class="statistics_wrap">
        <div class="tree_wrap">
            <me-tree
                ref="myTree"
                :treeData="treeList"
                :treeToolBar="false"
                :defaultProps="defaultProps"
                :nodeKey="'point_id'"
                :showCheckbox="true"
                :title="采集点"
                :cascadingVar="true"
                :checkStrictly.sync="checkStrictly"
                :isCheckClick="true"
                :defaultCheckKeys="defaultCheckKeys"
                :defaultExpandedKeys="defaultCheckKeys"
                @handleCheckBoxClick="handleTreeNodeClick"
            ></me-tree>
        </div>
        <div class="form_wrap h-full px-3 py-3">
            <el-form
                :model="searchForm"
                :inline="true"
                ref="searchForm"
                class="leader-style-form text-left"
            >
                <el-form-item
                    label="起始日期"
                    prop="start_date"
                    :rules="[
                        {
                            required: true,
                            message: '请选择起始日期',
                            trigger: 'change',
                        },
                    ]"
                >
                    <el-date-picker
                        v-model="searchForm.start_date"
                        align="right"
                        type="date"
                        :clearable="false"
                        placeholder="选择起始日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item
                    label="截止日期"
                    prop="end_date"
                    :rules="[
                        {
                            required: true,
                            message: '请选择截止日期',
                            trigger: 'change',
                        },
                    ]"
                >
                    <el-date-picker
                        v-model="searchForm.end_date"
                        align="right"
                        type="date"
                        :clearable="false"
                        placeholder="选择截止日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item style="float: right">
                    <el-button type="primary" @click="handleSearch">查询</el-button>
                    <el-button type="primary" @click="handleExport">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table border class="table-wrap leader-style-table" :data="tableList">
                <el-table-column align="center" label="序号" width="50">
                    <template slot-scope="scope">
                        <span>{{ (pageNum - 1) * pageSize + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="名称" property="point_name"></el-table-column>

                <el-table-column align="center" label="尖(kWh)" property="sharp_power"></el-table-column>
                <el-table-column align="center" label="峰(kWh)" property="peak_power"></el-table-column>
                <el-table-column align="center" label="平(kWh)" property="off_power"></el-table-column>
                <el-table-column align="center" label="谷(kWh)" property="shoulder_power"></el-table-column>
                <el-table-column align="center" label="有功总" property="total_power"></el-table-column>
                <el-table-column align="center" label="无功总" property="reactive_power"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                class="leader-style-pagination"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                style="margin-top: 20px"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import * as api from "@/http/api";
export default {
    components: {
        "me-tree": Tree
    },
    data() {
        return {
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            treeList: [],
            defaultCheckKeys: [],
            // 级联选择
            checkStrictly: true,
            searchForm: {
                start_date: "",
                end_date: ""
            },
            tableList: [],
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
        }
    },
    created() {
        this.getPointTree();
    },
    methods: {
        /**
        * @description: 获取系统时间
        */
        getSysDate() {
            api.getSysDate().then(res => {
                if (res && res.error_code == 0) {
                    this.searchForm.start_date = res.bus_json.sysdate;
                    this.searchForm.end_date = res.bus_json.sysdate;
                    this.getStatistics();
                }
            })
        },
        /**
        * @description: 获得采集点树
        */
        getPointTree() {
            api.getPointTree().then(res => {
                if (res && res.error_code == 0) {
                    this.treeList = res.bus_json;

                    this.defaultCheckKeys = [
                        res.bus_json &&
                        res.bus_json[0] &&
                        res.bus_json[0].point_id,
                    ];
                    this.getSysDate();
                }
            })
        },
        handleTreeNodeClick(select) {
            this.defaultCheckKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
        },
        /**
        * @description: 查询
        */
        handleSearch() {
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }

            this.getStatistics();
        },
        /**
        * @description: 导出
        */
        handleExport() {
            // const loading = this.$loading({
            //     lock: true,
            //     text: "下载中",
            //     spinner: "el-icon-loading",
            //     background: "rgba(0, 0, 0, 0.7)"
            // });
            let point_ids = this.defaultCheckKeys.join(",");

            api.getStatisticsExcel({
                start_date: this.searchForm.start_date,
                end_date: this.searchForm.end_date,
                point_ids: point_ids,
            }).then(res => {
                if (res) {
                    const content = res;
                    const blob = new Blob([content]);
                    const fileName = this.searchForm.start_date + "-" + this.searchForm.end_date + "数据统计.xlsx"
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        let evt = document.createEvent("MouseEvents");
                        evt.initEvent("click", false, false);
                        link.dispatchEvent(evt);
                        document.body.removeChild(link);
                    }
                    this.$message({
                        message: "下载成功！",
                        type: "success"
                    });
                }
                // loading.close();
            });
        },
        /**
        * @description: 列表
        */
        getStatistics() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",");
            params = {
                point_ids: point_ids,
                start_date: this.searchForm.start_date,
                end_date: this.searchForm.end_date,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            };
            this.$refs["searchForm"].validate(valid => {
                if (valid) {
                    // const loading = this.$loading({
                    //     lock: true,
                    //     text: 'Loading',
                    //     spinner: 'el-icon-loading',
                    //     background: 'rgba(0, 0, 0, 0.7)'
                    // });
                    api.getStatistics(params).then(res => {
                        if (res && res.error_code == 0) {
                            this.tableList = res.bus_json.items;
                            this.totalNum = res.bus_json.totalNum;
                            // loading.close();
                        } else {
                            // loading.close();
                        }
                    })
                }
            })

        },
        /**
        * 列表条数改变回调
        */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getStatistics();
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getStatistics();
        },
    }
}
</script>
<style lang="scss">
.statistics_wrap {
    width: 100%;
    height: 93%;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    .tree_wrap {
        width: 20%;
        height: 100%;
    }
    .form_wrap {
        width: 80%;
        height: 100%;
    }
}
</style>